import { useNavigate, useSearchParams } from 'react-router-dom';
import { ApiError } from '../../lib/api';
import { useCreateRoute } from '../../lib/queries';
import { SubScreen } from '../../ui/AppShell';
import { RouteForm } from './RouteForm';

export function NewRoutePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const create = useCreateRoute();
  const err = create.error;
  const serverError = err
    ? { message: err.message, fields: err instanceof ApiError ? err.fields : {} }
    : null;

  return (
    <SubScreen title="Nova rota" bare>
      <div className="app-head">
        <h1 className="display-title">Qual é a próxima viagem?</h1>
      </div>
      <RouteForm
        initialTripId={params.get('viagem')}
        pending={create.isPending}
        serverError={serverError}
        onSubmit={(input) =>
          create.mutate(input, { onSuccess: (route) => navigate(`/rotas/${route.id}`, { replace: true }) })
        }
      />
    </SubScreen>
  );
}
